import type { TextStyle, ViewStyle } from 'react-native'

import { BORDER_RADIUS, COLOR, ICON_SIZE, SPACE } from '@ui-kit/constants'

import type { CodeStatus, StatusColorMap } from './types'

export const STATUS_COLORS: StatusColorMap = {
  VERIFIED: COLOR.brandDark,
  INVALID: COLOR.uiRed,
}

export const containerStyles: TextStyle = {
  justifyContent: 'center',
  columnGap: SPACE.mini,
}

export const focusStyles: TextStyle = {
  borderColor: COLOR.brandDark,
}

export const selectionColor = COLOR.brandDark

export const getInputStyles = (
  codeStatus: CodeStatus | undefined,
  isSecure: boolean
): TextStyle => {
  return {
    textAlign: 'center',
    color: codeStatus ? STATUS_COLORS[codeStatus] : COLOR.uiDark,
    fontSize: isSecure === true ? 25 : 16,
  }
}

export const getFocusStickStyles = (codeStatus?: CodeStatus): ViewStyle => ({
  height: SPACE.small,
  width: BORDER_RADIUS.xsmall,
  alignItems: 'center',
  backgroundColor: codeStatus ? STATUS_COLORS[codeStatus] : COLOR.brandDark,
})

export const getInputContainerStyles = (codeStatus: CodeStatus | undefined): ViewStyle => {
  return {
    borderRadius: BORDER_RADIUS.normal,
    width: ICON_SIZE.large,
    height: SPACE.xlarge,
    borderWidth: 1.0,
    borderColor: codeStatus ? STATUS_COLORS[codeStatus] : COLOR.uiGreyMedium,
  }
}
